import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { listTerms, purchaseOrder } from "@/js/lists.ts";
import { formRules } from "@/js/form_rules.js";
export default {
  name: "SupplierDialog",
  components: {
    Address: function Address() {
      return import("@/components/address/Address.vue");
    }
  },
  props: {
    shown: Boolean,
    supplier: {
      type: Object,
      default: null
    },
    countries: {
      type: Array,
      default: []
    },
    states: {
      type: Array,
      default: []
    }
  },
  data: function data(_this) {
    return {
      isLoadingCountries: false,
      isSaving: false,
      form: {
        valid: false,
        terms: 1,
        address: {
          country: {}
        }
      },
      listPaymentMethods: Object.entries(purchaseOrder.paymentMethod).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (isNaN(key)) return acc;
        return [].concat(_toConsumableArray(acc), [{
          value: +key,
          label: value.text
        }]);
      }, []),
      listTerms: listTerms,
      rules: formRules
    };
  },
  computed: {
    isValidAddress: function isValidAddress() {
      var _address$country;
      var address = this.form.address;
      return address.street && address.city && ((_address$country = address.country) === null || _address$country === void 0 ? void 0 : _address$country.id_country);
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.supplier) {
              _this2.form = _objectSpread(_objectSpread({}, _this2.form), _this2.supplier);
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    close: function close() {
      this.$refs.formNewSupplier.reset();
      this.$emit("close");
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isSaving = true;
              _this = _this3;
              _this3.$emit("save", _this3.form, function () {
                _this.$refs.formNewSupplier.reset();
                _this.isSaving = false;
                _this.$emit("close");
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};